// import PrimaryButton from 'components/primaryButton';
import { ReactComponent as NoBlogIcon } from 'assets/icons/noBlogicon.svg';
import AdminBlogList from './adminstoriesList';
import useGetadminblogdata from '../hooks/useGetadminblogdata';
import { AuthContext } from 'context/authContext';
import { useContext } from 'react';

// import EmployeeBlogList from './employeeblogsList';

const MyStoriesAdmin = ({ isDraft, searchText, filterValue }) => {
  const { authState } = useContext(AuthContext);

  const adminBlogData = useGetadminblogdata({
    userId: authState.user_id,
    isDraft: isDraft,
    searchText: searchText,
    filterValue: filterValue,
  });

  return (
    <>
      {adminBlogData?.data?.data.length === 0 ? (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-4 flex justify-center items-center flex-col'>
          <NoBlogIcon />
          <p className='text-[#535353] mt-4 text-base'>
            Seems like you have no stories in draft
          </p>
        </div>
      ) : (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-5 w-full'>
          <div className=''>
            {adminBlogData?.data?.data.map((eachBlog) => (
              <div className='' key={eachBlog.id}>
                <AdminBlogList blogData={eachBlog} />
              </div>
            ))}
            {/* <AdminBlogList /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default MyStoriesAdmin;
